/* ZCT_V22_PRODUKT (E4): Produktseite wie PDP in v21 (JS-025 bis JS-031).
   - Galerie: Vorschaubilder, Wisch-Spur mit Einrasten, Zähler, Punkte; Bilder nur für die aktive Folie und ihre Nachbarn,
     sonst Ersatzfläche; nächstes Bild 500 ms nach dem Wechsel vorladen (link rel=preload, 720 px); aktives Vorschaubild
     sichtbar scrollen (smooth, nearest)
   - Zoom: Maus über dem Hauptbild zeigt .pdp-zoom (Hintergrund 2000 px, 200 %, Position der Maus)
   - Lightbox: Klick auf Folie oder Raumbild; Escape, Pfeiltasten, Wischen (40 px), Klick daneben schließt; Body ohne Scrollen
   - Oberfläche (Raster und Handy-Regler) und Größe: Variante, Preis, Bilder, Texte wie v21; nicht lieferbare Größe gesperrt;
     Wechsel setzt die Galerie ohne Animation auf Bild 1
   - Menge, In den Warenkorb (zctLaden.add: Schublade nach Bildladen, spätestens 300 ms), Merken, Aufklapper (immer einer offen
     oder keiner), Termin (zctTermin, JS-041) */
(function () {
  'use strict';
  // Bewegung komplett: Zeit-Token lesen; Shopify liefert das CSS verkleinert aus (200ms wird .2s), daher Sekunden und Millisekunden
  function zdZeit(v) { v = String(v || '').trim(); var x = parseFloat(v); if (isNaN(x)) return NaN; return /ms$/i.test(v) ? x : (/s$/i.test(v) ? x * 1000 : x); }
  function zctT(k) { try { var el = document.getElementById('zct-texte'), d = el ? JSON.parse(el.textContent) : {}; var v = d[k]; if (typeof v === 'string' && v.indexOf('&') >= 0) { var t = document.createElement('textarea'); t.innerHTML = v; v = t.value; } return v == null ? '' : v; } catch (e) { return ''; } }
  function ent(s) { if (typeof s !== 'string' || s.indexOf('&') < 0) return s; var t = document.createElement('textarea'); t.innerHTML = s; return t.value; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function url(basis, w) { if (!basis) return basis; if (!/(?:cdn\.shopify\.com|\/cdn\/shop\/)/.test(basis)) return basis; return basis + (basis.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }
  function satz(basis, ws) { return ws.map(function (w) { return url(basis, w) + ' ' + w + 'w'; }).join(', '); }
  function schluessel(u) { var i = u.indexOf('/files/'); if (i >= 0) return 'files/' + u.slice(i + 7); i = u.indexOf('/assets/'); if (i >= 0) return 'assets/' + u.slice(i + 8).replace(/\?v=\d+$/, ''); return u; }
  var PFEIL = '<svg class="ico " viewBox="0 0 16 16"><path d="M3 8h10m-4-4l4 4-4 4"></path></svg>';

  class ZctProdukt extends HTMLElement {
    connectedCallback() {
      if (this._zct) return; this._zct = true;
      var el = this;
      var D; try { D = JSON.parse(this.querySelector('#zct-pdp-daten').textContent); } catch (e) { return; }
      var L = window.zctLaden || {};
      var fmt = function (cent) { return L.fmt ? L.fmt(cent / 100) : String(cent / 100); };
      var toene = D.toene && D.toene.length ? D.toene : [D.ton];
      var st = { img: 0, finish: 0, size: 0, qty: 1, open: 'desc', lightbox: false };
      var sizeBtns = Array.prototype.slice.call(el.querySelectorAll('.size-grid .size'));
      st.size = Math.max(0, sizeBtns.findIndex(function (b) { return b.classList.contains('on'); }));

      // ---------- Ableitungen wie in der PDP von v21 ----------
      function ton() { return toene[st.finish] || D.ton; }
      function groesse() { return D.groessen[st.size] || D.groessen[0]; }
      // Handy-Figma: lange Maßangaben (z. B. „3 frei kombinierbare Module · je Modul …“) passen nicht in die Knöpfe; dann zeigt der Knopf
      // nur den Namen und die Angabe der gewählten Größe steht als Zeile darunter (Stile in zct-v26-handy.css, nur bis 768 px)
      function dimZeile() {
        var sg = el.querySelector('.size-grid');
        if (!sg) return;
        var lang = sizeBtns.some(function (b) { var d = b.querySelector('.dim'); return d && d.textContent.trim().length > 24; });
        sg.classList.toggle('zd-dim-lang', lang);
        var dz = sg.parentNode.querySelector('.zd-groesse-dim');
        if (lang) {
          if (!dz) { dz = document.createElement('div'); dz.className = 'zd-groesse-dim'; sg.after(dz); }
          var dd = sizeBtns[st.size] && sizeBtns[st.size].querySelector('.dim'), dt = dd ? dd.textContent.trim() : '';
          if (dz.textContent !== dt) dz.textContent = dt;
        } else if (dz) dz.remove();
      }
      dimZeile();
      // Größe passt, wenn Shopifys Wert dem deutschen Schlüssel oder dem Namen in der Seitensprache (kShop) entspricht
      function passtGroesse(v, g) {
        return [g.k, g.kShop].some(function (k) { return k && (v.o1 === k || v.t === k || String(v.t || '').indexOf(String(k) + ' /') === 0); });
      }
      function passtTon(v, t) {
        var w = ((v.o1 || '') + ' ' + (v.o2 || '') + ' ' + (v.t || '')).toLowerCase();
        var MESSING = ['messing', 'brass', 'laiton', 'latón', 'ottone'], STAHL = ['edelstahl', 'stainless', 'steel', 'acier', 'acero', 'acciaio'];
        var hat = function (l) { return l.some(function (x) { return w.indexOf(x) >= 0; }); };
        var mat = hat(MESSING) || hat(STAHL);
        if (!mat) return true;
        return t === 'brass' ? hat(MESSING) : hat(STAHL);
      }
      function variante() {
        var t = ton(), g = groesse();
        return D.varianten.find(function (v) { return passtGroesse(v, g) && passtTon(v, t); }) || D.varianten.find(function (v) { return passtTon(v, t); }) || null;
      }
      function bilder() {
        var t = ton(), v = variante(), vb = v && v.bild ? v.bild : null; if (D.erstbild && D.erstbild[t]) vb = null; // Louis 15.10.: gesetztes erstes Bild vor dem Variantenbild
        var seen = {}, liste = [];
        var add = function (src) { if (!src) return; var k = schluessel(src); if (seen[k]) return; seen[k] = 1; liste.push(src); };
        if (vb) add(vb);
        var tg = D.galerien[t] || [];
        if (tg.length) tg.forEach(function (e, i) { if (i === 0 && vb && D.erstesErsetzt) return; add(e); });
        else { var skip = !!(vb && D.erstesErsetzt); if (!skip) add(D.bild); (D.galerie || []).forEach(function (e, i) { if (i === 0 && skip) return; add(e); }); }
        return liste;
      }
      function preis() { // in Cent wie variantPrice * qty
        var v = variante(); var p = v ? v.preis : (groesse().preise[ton()] != null ? groesse().preise[ton()] * 100 : null);
        return p == null ? null : p * st.qty;
      }
      function einzelpreis() { var v = variante(); return v ? v.preis : (groesse().preise[ton()] != null ? groesse().preise[ton()] * 100 : null); }
      function alt(i) {
        if (i > 0) return D.name + ': ' + ent(D.ui.detail) + ' ' + (i + 1);
        var text = ent(D.ui.alt0), names = D.namen || {};
        var current = names[ton()], other = names[ton() === 'brass' ? 'steel' : 'brass'];
        return current && other ? text.replace(ent(other), ent(current)) : text;
      }

      // ---------- Galerie ----------
      var thumbs = el.querySelector('.gallery .thumbs');
      var mainImg = el.querySelector('.main-img');
      var scroller = el.querySelector('.pdp-scroll');
      var track = el.querySelector('.pdp-scroll-track');
      var hinweis = el.querySelector('.pdp-expand-hint');
      var aktuelle = bilder();
      // ZCT_V26: Renderings ganz zeigen (Klasse ph-ganz, Rand als Verlauf weitergeführt), Daten aus #zct-v26-bildarten
      var BA = (function () { try { return JSON.parse(document.getElementById('zct-v26-bildarten').textContent); } catch (e) { return {}; } })();
      // Einpassen wie snippets/zct-v26-ganz.liquid: Ausschnitt so legen, dass das Produkt ganz sichtbar bleibt (ph-fokus),
      // sonst ganz zeigen mit weitergeführtem Rand (ph-ganz). R = Seitenverhältnis der Fläche.
      function ganz(src, R) {
        var n = String(src || '').split('?')[0].split('/').pop(), e = BA[n];
        if (!e || !e.b) return { k: '', s: '' };
        var r = e.a, b = e.b, f = function (x) { return '#' + x.split('.').join(',#'); };
        R = R || 1.05;
        var breit = r > R, v = breit ? R / r : r / R, lo = breit ? b[0] : b[2], hi = breit ? b[1] : b[3];
        var passt = hi - lo - 0.04 <= v; // 2 % Luft je Seite darf angeschnitten werden
        // Fotos (f) nie ganz zeigen, der Rand als Verlauf passt nur zu Studiohintergründen: zu groß, dann Ausschnitt mittig aufs Produkt
        if (passt || e.f) {
          var rest = 1 - v, a = (lo + hi) / 2 - v / 2;
          if (passt) { a = Math.max(a, hi - v); a = Math.min(a, lo); }
          a = Math.max(0, Math.min(rest, a));
          var p = rest > 0.001 ? Math.round(a / rest * 1000) / 10 : 50;
          return { k: ' ph-fokus', s: ' style="--zd-pos:' + (breit ? p + '% 50%' : '50% ' + p + '%') + '"' };
        }
        if (breit) return { k: ' ph-ganz', s: ' style="background:linear-gradient(to right,' + f(e.o) + ') top/100% 50.5% no-repeat,linear-gradient(to right,' + f(e.u) + ') bottom/100% 50% no-repeat"' };
        return { k: ' ph-ganz', s: ' style="background:linear-gradient(' + f(e.l) + ') left/50.5% 100% no-repeat,linear-gradient(' + f(e.r) + ') right/50% 100% no-repeat"' };
      }
      function boxR(huelle) {
        if (huelle && huelle.closest && huelle.closest('.thumbs')) return 1;
        var m = el.querySelector('.main-img'); return m && m.clientHeight ? m.clientWidth / m.clientHeight : 1.05;
      }
      function phHtml(src, opt) {
        var g = ganz(src, opt.R);
        if (src) return '<div class="ph has-img' + g.k + ' "' + g.s + '><img src="' + esc(url(src, opt.max)) + '" srcset="' + esc(satz(src, opt.breiten)) + '" sizes="' + opt.sizes + '" alt="' + esc(opt.alt || opt.label || '') + '" loading="' + (opt.loading || 'lazy') + '"' + (opt.prio ? ' fetchpriority="' + opt.prio + '"' : '') + ' decoding="async" referrerpolicy="no-referrer"></div>';
        return '<div class="ph ' + esc(ton()) + ' ">' + (opt.label ? '<div class="label">' + esc(opt.label) + '</div>' : '') + (opt.center ? '<div class="centerlabel">' + esc(opt.center) + '</div>' : '') + '</div>';
      }
      // Bildfläche an Ort und Stelle ändern (wie React: gleiches img, neue Adresse), Wechsel Bild ↔ Ersatz durch Austausch
      function phSetzen(huelle, src, opt) {
        var alt0 = huelle.firstElementChild;
        var hatBild = alt0 && alt0.classList.contains('has-img');
        if (src && hatBild) {
          var im = alt0.querySelector('img');
          var s1 = url(src, opt.max), s2 = satz(src, opt.breiten), a = opt.alt || opt.label || '';
          if (im.getAttribute('src') !== s1) im.setAttribute('src', s1);
          if (im.getAttribute('srcset') !== s2) im.setAttribute('srcset', s2);
          if (im.getAttribute('alt') !== a) im.setAttribute('alt', a);
          if (opt.loading && im.getAttribute('loading') !== opt.loading) im.setAttribute('loading', opt.loading);
          if (opt.prio) { if (im.getAttribute('fetchpriority') !== opt.prio) im.setAttribute('fetchpriority', opt.prio); }
          // v26: ganz zeigen oder füllen je nach neuem Bild
          var g = ganz(src, boxR(huelle)), st0 = g.s ? g.s.slice(8, -1) : '';
          alt0.classList.toggle('ph-ganz', g.k === ' ph-ganz'); alt0.classList.toggle('ph-fokus', g.k === ' ph-fokus');
          if (st0) { if (alt0.getAttribute('style') !== st0) alt0.setAttribute('style', st0); } else if (alt0.hasAttribute('style')) alt0.removeAttribute('style');
          return;
        }
        if (!src && alt0 && !hatBild) {
          var k = 'ph ' + ton() + ' '; if (alt0.className !== k) alt0.className = k;
          var h = (opt.label ? '<div class="label">' + esc(opt.label) + '</div>' : '') + (opt.center ? '<div class="centerlabel">' + esc(opt.center) + '</div>' : '');
          if (alt0.innerHTML !== h) alt0.innerHTML = h;
          return;
        }
        opt.R = boxR(huelle);
        var tmp = document.createElement('div'); tmp.innerHTML = phHtml(src, opt);
        if (alt0) alt0.replaceWith(tmp.firstChild); else huelle.appendChild(tmp.firstChild);
      }
      function folienOpt(i) {
        var nr = String(i + 1); if (nr.length < 2) nr = '0' + nr;
        return { max: 2000, breiten: [480, 720, 960, 1200, 1600, 2000], sizes: '(max-width: 900px) 100vw, 58vw', alt: alt(i), loading: i === st.img ? 'eager' : 'lazy', prio: i === st.img ? 'high' : 'auto',
          label: i === 0 ? D.mono : null, center: D.name + ' · ' + ent(D.ui.ansichtGross) + ' ' + nr };
      }
      var folienSchluessel = aktuelle.map(function (s, i) { return s + '-' + i; }).join('|');
      function galerieZeichnen(neueListe) {
        var liste = aktuelle;
        // Vorschaubilder (Index-Schlüssel: Knöpfe bleiben, Bilder wechseln an Ort und Stelle)
        while (thumbs.children.length > liste.length) thumbs.lastElementChild.remove();
        liste.forEach(function (src, i) {
          var b = thumbs.children[i];
          var k = st.img === i ? 'on' : '';
          if (!b) { b = document.createElement('button'); b.className = k; thumbs.appendChild(b); b.addEventListener('click', function () { gehe(Array.prototype.indexOf.call(thumbs.children, b)); }); }
          if (b.className !== k || !b.hasAttribute('class')) b.className = k;
          phSetzen(b, src, { max: 288, breiten: [96, 144, 192, 288], sizes: '72px', alt: alt(i), loading: 'lazy', prio: 'low' });
        });
        // Folien (Schlüssel Adresse + Index: bei neuer Liste neu, sonst nur Bild bzw. Ersatz je nach Nähe zur aktiven Folie)
        var sk = liste.map(function (s, i) { return s + '-' + i; }).join('|');
        if (neueListe || sk !== folienSchluessel) {
          folienSchluessel = sk;
          var R0 = boxR(track);
          track.innerHTML = liste.map(function (src, i) { var o = folienOpt(i); o.R = R0; return '<div class="pdp-scroll-slide">' + phHtml(Math.abs(i - st.img) <= naheFolien() ? src : null, o) + '</div>'; }).join('');
        } else {
          Array.prototype.forEach.call(track.children, function (f, i) { phSetzen(f, Math.abs(i - st.img) <= naheFolien() ? liste[i] : null, folienOpt(i)); });
        }
        // Bewegung komplett (Plan 007): zwei Nachbarn je Seite bekommen ihr Bild (vorher einer: beim schnellen Wischen blitzten Ersatzflächen auf);
        // Bilder ab Folie 2 blenden beim Laden in --zd-dauer-klein ein, die erste nie (größtes Bild der Seite, darf nicht warten)
        Array.prototype.forEach.call(track.children, function (f, i) {
          var im = i > 0 && f.querySelector('img');
          if (!im || im._zdEin === im.getAttribute('src')) return;
          im._zdEin = im.getAttribute('src');
          if (!im.complete) { im.classList.add('zd-laedt'); var los = function () { im.classList.remove('zd-laedt'); }; im.addEventListener('load', los, { once: true }); im.addEventListener('error', los, { once: true }); }
        });
        // Zähler und Punkte
        var zaehler = mainImg.querySelector('.pdp-slide-count'), punkte = mainImg.querySelector('.gallery-dots');
        if (liste.length > 1) {
          if (!zaehler) { zaehler = document.createElement('div'); zaehler.className = 'pdp-slide-count'; scroller.after(zaehler); }
          var zw = function (n) { return n < 10 ? '0' + n : String(n); }; // Figma: „01 / 11“
          var z = zw(st.img + 1) + ' / ' + zw(liste.length); if (zaehler.textContent !== z) zaehler.textContent = z;
          if (!punkte) { punkte = document.createElement('div'); punkte.className = 'gallery-dots'; zaehler.after(punkte); }
          while (punkte.children.length > liste.length) punkte.lastElementChild.remove();
          liste.forEach(function (s, i) {
            var p = punkte.children[i];
            var k = st.img === i ? 'on' : '';
            if (!p) { p = document.createElement('button'); p.className = k; punkte.appendChild(p); }
            if (p.className !== k || !p.hasAttribute('class')) p.className = k;
            p.setAttribute('aria-label', D.name + ' ' + ent(D.ui.ansicht) + ' ' + (i + 1));
            p.setAttribute('aria-pressed', String(st.img === i));
          });
        } else { if (zaehler) zaehler.remove(); if (punkte) punkte.remove(); }
        // Handy-Figma: Pfeil „nächstes Bild“ rechts in der Mitte (nur bis 768 px sichtbar), am letzten Bild ausgeblendet
        var weiter = mainImg.querySelector('.zd-galerie-weiter');
        if (liste.length > 1) {
          if (!weiter) { weiter = document.createElement('button'); weiter.type = 'button'; weiter.className = 'zd-galerie-weiter'; weiter.setAttribute('aria-label', zctT('v25_bild_naechstes') || '›');
            weiter.innerHTML = '<svg class="ico" viewBox="0 0 16 16" aria-hidden="true"><path d="M4 6l4 4 4-4"></path></svg>'; mainImg.appendChild(weiter); }
          weiter.hidden = st.img >= liste.length - 1;
        } else if (weiter) weiter.remove();
        // Louis 15.10. (Figma Rechner): Pfeile links und rechts in der Bühne (sichtbar ab 1024 px), am Anfang bzw. Ende abgeschwächt
        ['zurueck', 'vor'].forEach(function (r) {
          var pf = mainImg.querySelector('.zd-galerie-pfeil.zd-' + r);
          if (liste.length > 1) {
            if (!pf) { pf = document.createElement('button'); pf.type = 'button'; pf.className = 'zd-galerie-pfeil zd-' + r; pf.setAttribute('aria-label', zctT(r === 'vor' ? 'v25_bild_naechstes' : 'v25_bild_vorher') || (r === 'vor' ? '›' : '‹'));
              pf.innerHTML = '<svg viewBox="0 0 20 20" aria-hidden="true"><path d="' + (r === 'vor' ? 'M8 4l6 6-6 6' : 'M12 4l-6 6 6 6') + '"></path></svg>'; mainImg.appendChild(pf); }
            pf.disabled = r === 'vor' ? st.img >= liste.length - 1 : st.img <= 0;
          } else if (pf) pf.remove();
        });
        // Raumbilder (ab 3 Bildern)
        var raum = el.querySelector('.pdp-room-grid');
        if (liste.length >= 3) {
          if (!raum) {
            raum = document.createElement('div'); raum.className = 'pdp-room-grid';
            raum.setAttribute('style', 'display: grid; grid-template-columns: 1fr 1fr; gap: 10px; margin-top: 10px;');
            raum.innerHTML = '<div style="aspect-ratio: 1 / 1; position: relative; border: 1px solid var(--line); cursor: pointer;"></div><div style="aspect-ratio: 1 / 1; position: relative; border: 1px solid var(--line); cursor: pointer;"></div>';
            mainImg.after(raum); raumKlicks(raum);
          }
          phSetzen(raum.children[0], liste[1], { max: 960, breiten: [360, 540, 720, 960], sizes: '(max-width: 900px) 50vw, 29vw', label: ent(D.ui.imRaum) });
          phSetzen(raum.children[1], liste[2], { max: 960, breiten: [360, 540, 720, 960], sizes: '(max-width: 900px) 50vw, 29vw', label: zctT('v25_bild_detail') || 'DETAIL' });
        } else if (raum) raum.remove();
        zoomZeichnen();
        lightboxZeichnen();
      }
      function aktivSetzen(n) {
        if (n === st.img) return;
        st.img = n;
        galerieZeichnen(false);
        var t = thumbs.children[st.img]; if (t) t.scrollIntoView({ behavior: window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        vorladen();
      }
      function gehe(ziel) {
        var idx = Math.max(0, Math.min(aktuelle.length - 1, ziel));
        // Plan 007: Nachbarbild gleitet (räumlich), weite Sprünge sofort (vorher fuhr die Galerie durch alle Zwischenbilder, Zähler flackerte)
        var weit = Math.abs(idx - st.img) > 1;
        aktivSetzen(idx);
        scroller.scrollTo({ left: scroller.clientWidth * idx, behavior: weit ? 'instant' : (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth') });
      }
      var scrollGeplant = false; // Plan 007: höchstens einmal pro Bild auswerten
      scroller.addEventListener('scroll', function () {
        gewischt = true;
        if (scrollGeplant) return; scrollGeplant = true;
        requestAnimationFrame(function () {
          scrollGeplant = false;
          var n = Math.max(0, Math.min(aktuelle.length - 1, Math.round(scroller.scrollLeft / Math.max(1, scroller.clientWidth))));
          aktivSetzen(n);
        });
      }, { passive: true });
      Array.prototype.forEach.call(thumbs.children, function (b) { b.addEventListener('click', function () { gehe(Array.prototype.indexOf.call(thumbs.children, b)); }); });
      mainImg.addEventListener('click', function (e) {
        var p = e.target.closest('.gallery-dots button');
        if (p) { e.stopPropagation(); gehe(Array.prototype.indexOf.call(p.parentNode.children, p)); return; }
        if (e.target.closest('.zd-galerie-weiter')) { e.stopPropagation(); gehe(st.img + 1); return; }
        var pf = e.target.closest('.zd-galerie-pfeil'); if (pf) { e.stopPropagation(); if (!pf.disabled) gehe(st.img + (pf.classList.contains('zd-vor') ? 1 : -1)); return; }
        if (e.target.closest('.pdp-scroll-slide')) lightboxAuf();
      });
      // Louis 15.10. (Revision V1): am Rechner mit der Maus ziehen = wischen (Trackpad und Finger wischen den Slider nativ).
      // Folgt dem Zeiger; beim Loslassen zur Nachbarfolie ab 20 % Weg oder schnellem Zug (> 0,11 px/ms), sonst zurück. Ein Zug löst keine Großansicht aus.
      (function () {
        var zug = null;
        scroller.addEventListener('dragstart', function (e) { e.preventDefault(); });
        scroller.addEventListener('pointerdown', function (e) {
          if (e.pointerType !== 'mouse' || e.button !== 0 || aktuelle.length < 2) return;
          zug = { x: e.clientX, l: scroller.scrollLeft, t: performance.now(), i: st.img, bewegt: false };
        });
        window.addEventListener('pointermove', function (e) {
          if (!zug) return;
          var dx = e.clientX - zug.x;
          if (!zug.bewegt) { if (Math.abs(dx) < 6) return; zug.bewegt = true; scroller.style.scrollSnapType = 'none'; scroller.style.scrollBehavior = 'auto'; scroller.classList.add('zd-zieht'); }
          scroller.scrollLeft = zug.l - dx;
        });
        window.addEventListener('pointerup', function (e) {
          if (!zug) return;
          var z = zug; zug = null;
          if (!z.bewegt) return;
          var dx = e.clientX - z.x, tempo = Math.abs(dx) / Math.max(1, performance.now() - z.t);
          var ziel = (Math.abs(dx) > scroller.clientWidth * 0.2 || tempo > 0.11) ? z.i + (dx < 0 ? 1 : -1) : z.i;
          scroller.style.scrollSnapType = ''; scroller.style.scrollBehavior = ''; scroller.classList.remove('zd-zieht');
          gehe(ziel);
          var stopp = function (ev) { ev.stopPropagation(); ev.preventDefault(); };
          mainImg.addEventListener('click', stopp, { capture: true, once: true });
          setTimeout(function () { mainImg.removeEventListener('click', stopp, true); }, 60);
        });
      })();
      function raumKlicks(raum) {
        raum.children[0].addEventListener('click', function () { gehe(1); lightboxAuf(); });
        raum.children[1].addEventListener('click', function () { gehe(2); lightboxAuf(); });
      }
      var raum0 = el.querySelector('.pdp-room-grid'); if (raum0) raumKlicks(raum0);
      // v26: Einpassen an die echte Größe der Bildfläche (Handy hochkant, Rechner fast quadratisch), auch nach Größenänderung
      var einpassUhr = null;
      function neuEinpassen() { clearTimeout(einpassUhr); einpassUhr = setTimeout(function () { galerieZeichnen(false); }, 150); }
      window.addEventListener('resize', neuEinpassen);
      requestAnimationFrame(function () { galerieZeichnen(false); });
      // Vorladen des nächsten Bildes (500 ms nach Wechsel)
      var vorladenUhr = null, vorgeladen = {};
      function vorladen() {
        clearTimeout(vorladenUhr);
        var next = aktuelle[st.img + 1]; if (!next) return;
        vorladenUhr = setTimeout(function () {
          var href = url(next, 720); if (vorgeladen[href]) return; vorgeladen[href] = 1;
          try {
            if (document.head.querySelector('link[rel="preload"][as="image"][href="' + CSS.escape(href) + '"]')) return;
            var link = document.createElement('link'); link.rel = 'preload'; link.as = 'image'; link.href = href;
            link.imageSrcset = satz(next, [360, 540, 720, 960, 1200, 1600]); link.imageSizes = '(max-width: 680px) 92vw, (max-width: 1100px) 48vw, 560px';
            link.fetchPriority = 'low'; link.dataset.pdpImagePreload = 'true'; document.head.appendChild(link);
          } catch (e) {}
        }, 500);
      }
      // Zoom
      // Plan 007: die Lupe bleibt im DOM und blendet in --zd-dauer-klein ein und aus (vorher sprang sie an und ab); Position höchstens einmal pro Bild
      var zoom = null, zoomGeplant = false;
      function zoomZeichnen() {
        var z = mainImg.querySelector('.pdp-zoom');
        if (!z) { if (!zoom) return; z = document.createElement('div'); z.className = 'pdp-zoom'; hinweis.before(z); }
        if (!zoom) { z.classList.remove('ist-an'); return; }
        var bg = 'url("' + url(aktuelle[st.img], 2000) + '")';
        if (z._zdBg !== bg) { z._zdBg = bg; z.style.backgroundImage = bg; z.style.backgroundSize = '200%'; }
        z.style.backgroundPosition = zoom.x + '% ' + zoom.y + '%';
        if (!z.classList.contains('ist-an')) { z.getBoundingClientRect(); z.classList.add('ist-an'); }
      }
      var zdSlider = window.matchMedia('(min-width: 1024px)'); // Louis 15.10.: am Rechner Slider statt Lupe beim Überfahren (Großansicht per Klick bleibt)
      mainImg.addEventListener('mousemove', function (e) {
        if (zdSlider.matches) { if (zoom) { zoom = null; zoomZeichnen(); } return; }
        var r = mainImg.getBoundingClientRect(); zoom = { x: (e.clientX - r.left) / r.width * 100, y: (e.clientY - r.top) / r.height * 100 };
        if (zoomGeplant) return; zoomGeplant = true; requestAnimationFrame(function () { zoomGeplant = false; zoomZeichnen(); });
      });
      mainImg.addEventListener('mouseleave', function () { zoom = null; zoomZeichnen(); });

      // ---------- Lightbox ----------
      // Bewegung komplett (Plan 002): Blättern führt die Galerie dahinter sofort mit (sonst steht dort nach dem Schließen eine Ersatzfläche),
      // Schließen blendet in --zd-dauer-fenster-zu aus, Wischen folgt dem Finger und zählt die Geschwindigkeit (emil-animate: Drag to dismiss).
      // Plan 007 (nach der Messung): beim Laden nur das direkte Nachbarbild (keine zusätzlichen Daten), ab dem ersten Wischen zwei je Seite
      var gewischt = false;
      function naheFolien() { return gewischt ? 2 : 1; }
      var lb = null, lbWisch = null;
      function zdMs(n, f) { var v = zdZeit(getComputedStyle(document.documentElement).getPropertyValue(n)); return isNaN(v) ? f : v; }
      function ruhig() { return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches); }
      function lbGehe(n) { aktivSetzen(n); scroller.scrollTo({ left: scroller.clientWidth * st.img, behavior: 'instant' }); }
      function lbNaechstes(r) { lbGehe((st.img + r + aktuelle.length) % aktuelle.length); }
      function lightboxAuf() { if (st.lightbox) return; st.lightbox = true; lightboxZeichnen(); document.addEventListener('keydown', lbTaste); document.documentElement.classList.add('zd-gesperrt-fenster'); }
      function lightboxZu() { if (!st.lightbox) return; st.lightbox = false; lightboxZeichnen(); document.removeEventListener('keydown', lbTaste); document.documentElement.classList.remove('zd-gesperrt-fenster'); }
      function lbTaste(e) {
        if (e.key === 'Escape') lightboxZu();
        if (e.key === 'ArrowRight') lbNaechstes(1);
        if (e.key === 'ArrowLeft') lbNaechstes(-1);
      }
      function lbZurueck(im) { im.style.transition = 'none'; im.style.transform = ''; im.getBoundingClientRect(); im.style.transition = ''; }
      function lightboxZeichnen() {
        if (!st.lightbox) {
          if (lb) { var alt = lb; lb = null; alt.classList.add('zd-schliesst'); setTimeout(function () { alt.remove(); }, zdMs('--zd-dauer-fenster-zu', 150) + 40); }
          return;
        }
        if (!lb) {
          lb = document.createElement('div'); lb.className = 'lightbox'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', D.name);
          lb.innerHTML = '<button class="lb-close" aria-label="' + zctT('schliessen') + '">×</button><button class="lb-nav lb-prev">‹</button><img><button class="lb-nav lb-next">›</button><div class="lb-counter"></div>';
          lb.addEventListener('click', function () { lightboxZu(); });
          lb.querySelector('.lb-close').addEventListener('click', function (e) { e.stopPropagation(); lightboxZu(); });
          lb.querySelector('.lb-prev').addEventListener('click', function (e) { e.stopPropagation(); lbNaechstes(-1); });
          lb.querySelector('.lb-next').addEventListener('click', function (e) { e.stopPropagation(); lbNaechstes(1); });
          var im = lb.querySelector('img');
          im.addEventListener('click', function (e) { e.stopPropagation(); });
          // Wischen: nur der erste Finger; Bild folgt direkt; Wechsel ab 60 px oder bei schnellem Wisch (> 0,11 px/ms), sonst federt es über den CSS-Übergang zurück
          im.addEventListener('touchstart', function (e) { if (lbWisch || e.touches.length > 1) return; lbWisch = { x: e.touches[0].clientX, t: performance.now(), dx: 0 }; im.style.transition = 'none'; }, { passive: true });
          im.addEventListener('touchmove', function (e) { if (!lbWisch) return; lbWisch.dx = e.touches[0].clientX - lbWisch.x; im.style.transform = 'translateX(' + lbWisch.dx + 'px)'; }, { passive: true });
          function lbLos() {
            if (!lbWisch) return; var w = lbWisch; lbWisch = null;
            var v = Math.abs(w.dx) / Math.max(1, performance.now() - w.t);
            if (Math.abs(w.dx) > 60 || (Math.abs(w.dx) > 12 && v > 0.11)) {
              lbZurueck(im); lbNaechstes(w.dx < 0 ? 1 : -1);
              if (im.animate && !ruhig()) im.animate([{ opacity: 0 }, { opacity: 1 }], { duration: zdMs('--zd-dauer-klein', 150), easing: 'ease' });
            } else { im.style.transition = ''; im.style.transform = ''; }
          }
          im.addEventListener('touchend', lbLos); im.addEventListener('touchcancel', lbLos);
          el.appendChild(lb);
        }
        var img = lb.querySelector('img'), s = url(aktuelle[st.img], 2000);
        if (img.getAttribute('src') !== s) img.setAttribute('src', s);
        img.setAttribute('alt', alt(st.img));
        lb.querySelector('.lb-counter').textContent = (st.img + 1) + ' / ' + aktuelle.length;
      }

      // ---------- Infos (Oberfläche, Größe, Preis, Texte) ----------
      var info = el.querySelector('.pdp .info');
      function infoZeichnen() {
        var t = ton(), g = groesse();
        // Oberfläche
        var lblTon = info.querySelector('.finish-grid') && info.querySelector('.finish-grid').parentNode.querySelector('.lbl b');
        if (lblTon) lblTon.textContent = D.namen[t];
        info.querySelectorAll('.finish-grid .finish').forEach(function (b, i) { var k = 'finish ' + (st.finish === i ? 'on' : ''); if (b.className !== k) b.className = k; b.setAttribute('aria-pressed', String(st.finish === i)); });
        var slider = el.querySelector('.pdp-tone-slider'); if (slider) slider.style.transform = 'translateX(' + (st.finish * 100) + '%)';
        el.querySelectorAll('.pdp-tone-btn').forEach(function (b, i) { var k = 'pdp-tone-btn' + (st.finish === i ? ' on' : ''); if (b.className !== k) b.className = k; });
        // Kurztext
        var kurz = info.querySelector('p.short');
        if (kurz && !D.v19) { var c = D.texte[t] || {}; kurz.innerHTML = esc(c.desc) + (c.tagline ? ' <em style="color: var(--brass-deep);">' + esc(c.tagline) + '.</em>' : ''); }
        // Größe
        var lblGr = info.querySelector('.size-grid') && info.querySelector('.size-grid').parentNode.querySelector('.lbl b');
        if (lblGr) lblGr.textContent = g.kText;
        sizeBtns.forEach(function (b, i) {
          var s = D.groessen[i], na = s && s.preise && s.preise[t] == null;
          var k = 'size ' + (st.size === i ? 'on' : '') + (na ? ' size-na' : ''); if (b.className !== k) b.className = k;
          // wie React: gesperrt mit Stil; danach bleibt ein leeres style-Attribut stehen
          if (na) { b.disabled = true; b.setAttribute('style', 'opacity: 0.35; cursor: not-allowed;'); } else { b.disabled = false; if (b.hasAttribute('style')) b.setAttribute('style', ''); }
          b.setAttribute('aria-pressed', String(st.size === i));
        });
        dimZeile();
        // Preis (Wechsel zwischen Preis und „auf Anfrage“ kommt mit den heutigen Daten nicht vor; dann bleibt die
        // Kaufleiste stehen und nur der Betrag wechselt nicht)
        var p = preis();
        var preisEl = info.querySelector('.price');
        var mobil = el.querySelector('.pdp-cta-mobile');
        if (p != null && preisEl.querySelector('.vat')) {
          preisEl.firstChild.nodeValue = fmt(p) + ' ';
          var nEl = info.querySelector('.qbox .n'); if (nEl) nEl.textContent = String(st.qty);
          var kauf = info.querySelector('[data-zct-pdp-kaufen]'); if (kauf) kauf.innerHTML = esc(ent(D.ui.warenkorb)) + ' · ' + esc(fmt(p)) + ' ' + PFEIL;
          var mp = mobil && mobil.querySelector('.price'); if (mp) mp.textContent = fmt(p);
        }
        // Darunter: Beschreibung, Pflege, Maße, Material, Gewicht
        var txt = el.querySelector('[data-zct-pdp-text]');
        // v26: steht „Die Geschichte“ auf der Seite, kommt die Geschichte dorthin und der Aufklapper zeigt nur die Beschreibung
        var gesch = document.querySelector('[data-zct-pdp-geschichte]');
        if (gesch && !D.v19) {
          var cg = D.texte[t] || {};
          if (cg.story) gesch.innerHTML = cg.story.split('\n').filter(function (a) { return a.trim(); }).map(function (a) { return '<p>' + esc(a.trim()) + '</p>'; }).join('');
        }
        if (txt && (!D.v19 || gesch)) {
          var c2 = D.texte[t] || {};
          var voll = gesch ? (c2.desc || '') + ' ' + ent(D.satz) : (c2.desc || '') + (c2.story ? '\n\n' + c2.story : '') + ' ' + ent(D.satz);
          if (voll.indexOf('\n') >= 0) txt.innerHTML = voll.split('\n').filter(Boolean).map(function (a, i) { return '<p style="margin: ' + (i > 0 ? '12px 0px 0px' : '0px') + ';">' + esc(a) + '</p>'; }).join('');
          else txt.textContent = voll;
        }
        var pt = el.querySelector('[data-zct-pdp-pflege-titel]'); if (pt) pt.firstChild.nodeValue = ent(D.pflege[t].titel);
        var px = el.querySelector('[data-zct-pdp-pflege-text]'); if (px) px.textContent = ent(D.pflege[t].text);
        var ma = el.querySelector('[data-zct-pdp-masse]'); if (ma && g.dimText) ma.textContent = g.dimText;
        var mt = el.querySelector('[data-zct-pdp-material]'); if (mt) mt.textContent = D.namen[t];
        var gw = el.querySelector('[data-zct-pdp-gewicht]'); if (gw && g.gewicht != null && g.gewicht !== '') gw.textContent = String(g.gewicht).replace('.', ',') + ' kg'; // ohne Wert bleibt der Steckbrief-Wert stehen (nie „—“)
      }
      // Wechsel von Oberfläche oder Größe: Bilder neu, Galerie auf Bild 1. Plan 007: wirklich ohne Fahrt ('instant'; 'auto' übernahm das weiche
      // Scrollen aus dem CSS), und das alte Bild liegt als Kopie darüber und blendet in --zd-dauer-aufklapper aus, sobald das neue da ist
      // (gleiche Silhouette, keine Doppelbelichtung). „Bewegung reduzieren“: harter Tausch wie bisher.
      function kurve() { return (getComputedStyle(document.documentElement).getPropertyValue('--zd-kurve-aus') || '').trim() || 'cubic-bezier(0.23, 1, 0.32, 1)'; }
      function folienKopie() {
        var f = track.children[st.img], im = f && f.querySelector('img');
        if (!im || !im.complete || !im.naturalWidth) return null;
        var r = im.getBoundingClientRect(), m = mainImg.getBoundingClientRect(), cs = getComputedStyle(im);
        var k = im.cloneNode(); k.removeAttribute('loading'); k.removeAttribute('fetchpriority'); k.className = 'zd-bild-kopie'; k.alt = ''; k.setAttribute('aria-hidden', 'true');
        k.style.cssText = 'position:absolute;margin:0;left:' + (r.left - m.left) + 'px;top:' + (r.top - m.top) + 'px;width:' + r.width + 'px;height:' + r.height + 'px;object-fit:' + cs.objectFit + ';object-position:' + cs.objectPosition + ';pointer-events:none;z-index:5';
        mainImg.appendChild(k); return k;
      }
      function kopieAusblenden(k) {
        var los = false;
        function weg() { if (los) return; los = true; var an = k.animate([{ opacity: 1 }, { opacity: 0 }], { duration: zdMs('--zd-dauer-aufklapper', 200), easing: kurve() }); an.onfinish = an.oncancel = function () { k.remove(); }; }
        var f = track.children[0], im = f && f.querySelector('img');
        if (!im || im.complete) weg(); else { im.addEventListener('load', weg, { once: true }); im.addEventListener('error', weg, { once: true }); setTimeout(weg, 600); }
      }
      function auswahlGeaendert() {
        var neu = bilder();
        var geaendert = neu.join('|') !== aktuelle.join('|');
        var kopie = geaendert && !ruhig() ? folienKopie() : null;
        aktuelle = neu;
        st.img = 0;
        scroller.scrollTo({ left: 0, behavior: 'instant' });
        galerieZeichnen(geaendert);
        if (kopie) kopieAusblenden(kopie);
        infoZeichnen();
        vorladen();
      }
      function groesseFuerTon(t) {
        var g = D.groessen[st.size];
        if (g && g.preise && g.preise[t] == null) { var vi = D.groessen.findIndex(function (s) { return s && s.preise && s.preise[t] != null; }); if (vi >= 0) st.size = vi; }
      }
      el.querySelectorAll('.finish-grid .finish').forEach(function (b, i) { b.addEventListener('click', function () { if (st.finish === i) return; st.finish = i; groesseFuerTon(ton()); auswahlGeaendert(); }); });
      el.querySelectorAll('.pdp-tone-btn').forEach(function (b, i) { b.addEventListener('click', function () { if (st.finish === i) return; st.finish = i; groesseFuerTon(ton()); auswahlGeaendert(); }); });
      sizeBtns.forEach(function (b, i) { b.addEventListener('click', function () { var s = D.groessen[i]; if (s && s.preise && s.preise[ton()] == null) return; if (st.size === i) return; st.size = i; auswahlGeaendert(); }); });
      var qbox = el.querySelectorAll('.qbox button');
      if (qbox.length === 2) {
        qbox[0].addEventListener('click', function () { st.qty = Math.max(1, st.qty - 1); infoZeichnen(); });
        qbox[1].addEventListener('click', function () { st.qty = st.qty + 1; infoZeichnen(); });
      }
      // In den Warenkorb (wie handleAdd)
      el.querySelectorAll('[data-zct-pdp-kaufen]').forEach(function (b) {
        b.addEventListener('click', function () {
          var ep = einzelpreis(); if (ep == null || !L.add) return;
          // Vorläufige Zeile gleich mit Shopifys Namen der gewählten Variante (Seitensprache), damit nach der Antwort nichts umspringt
          var v = variante(), standard = v && (v.t === 'Default Title' || v.o1 === 'Default Title');
          L.add({ id: D.id, variantId: v ? v.id : undefined, name: D.titel || D.name, tone: ton(), img: aktuelle[0] || D.bild, price: ep / 100,
            size: v ? (standard ? '' : v.o1 || '') : groesse().k, finish: v ? (standard ? '' : v.o2 || '') : D.namen[ton()], qty: st.qty });
        });
      });
      // Termin (Beratung, Preis anfragen)
      el.querySelectorAll('[data-zct-pdp-termin]').forEach(function (b) { b.addEventListener('click', function () { if (window.zctTermin) window.zctTermin.oeffnen({ name: D.name }); }); });
      // Merken
      var herz = el.querySelector('[data-zct-pdp-merken]');
      function herzZeichnen() {
        if (!herz) return;
        var an = ((L.wish && L.wish()) || []).indexOf(D.id) >= 0;
        var k = 'nav-icon link pdp-wish' + (an ? ' on' : ''); if (herz.className !== k) herz.className = k;
        herz.setAttribute('aria-label', ent(an ? D.ui.entfernen : D.ui.merken));
        herz.style.background = an ? 'var(--paper-3)' : 'transparent';
      }
      if (herz) herz.addEventListener('click', function () {
        if (L.toggleWish) L.toggleWish(D.id); herzZeichnen();
        if (window.zctPuls && L.wish && (L.wish() || []).indexOf(D.id) >= 0) window.zctPuls(herz.querySelector('svg') || herz); // Plan 013
      });
      window.addEventListener('zct:laden', herzZeichnen);
      herzZeichnen();
      // Aufklapper „Mehr über das Produkt“ (Bewegung komplett, Plan 006): wie alle Aufklapper – unabhängig voneinander (der angeklickte
      // Kopf bleibt stehen), Öffnen --zd-dauer-aufklapper, Schließen --zd-dauer-aufklapper-zu, --zd-kurve-aus; Höhe, unteres Polster und
      // Deckkraft gemeinsam (vorher sprang das 20-px-Polster); data-zd-ziel sofort beim Klick (Symbol wartet nicht). „Bewegung reduzieren“: sofort.
      var accRuhig = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
      function accKlappen(a, auf) {
        var body = a.querySelector('.body');
        a.setAttribute('data-zd-ziel', auf ? 'auf' : 'zu');
        if (!body || !body.animate || (accRuhig && accRuhig.matches)) { a.className = 'acc ' + (auf ? 'open' : ''); return; }
        var warOffen = a.classList.contains('open'), cs = getComputedStyle(body);
        var von = warOffen ? body.getBoundingClientRect().height : 0;
        var opVon = warOffen ? parseFloat(cs.opacity) : 0; if (isNaN(opVon)) opVon = 1;
        var pbVon = warOffen ? cs.paddingBottom : '0px';
        body.getAnimations().forEach(function (x) { x.cancel(); });
        a.className = 'acc open';
        body.style.boxSizing = 'border-box'; body.style.overflow = 'hidden';
        var pbVoll = getComputedStyle(body).paddingBottom;
        var ziel = auf ? body.getBoundingClientRect().height : 0;
        var kurve = (getComputedStyle(document.documentElement).getPropertyValue('--zd-kurve-aus') || '').trim() || 'cubic-bezier(0.23, 1, 0.32, 1)';
        var an = body.animate([{ height: von + 'px', paddingBottom: pbVon, opacity: opVon }, { height: ziel + 'px', paddingBottom: auf ? pbVoll : '0px', opacity: auf ? 1 : 0 }],
          { duration: zdMs(auf ? '--zd-dauer-aufklapper' : '--zd-dauer-aufklapper-zu', auf ? 200 : 160), easing: kurve });
        an.onfinish = function () { body.style.overflow = ''; body.style.boxSizing = ''; if (!auf) a.className = 'acc '; };
      }
      el.querySelectorAll('.pdp-below .acc > button.head').forEach(function (k) {
        var a0 = k.parentNode; k.setAttribute('aria-expanded', String(a0.classList.contains('open')));
        k.addEventListener('click', function () {
          var a = k.parentNode;
          var ist = a.hasAttribute('data-zd-ziel') ? a.getAttribute('data-zd-ziel') === 'auf' : a.classList.contains('open');
          accKlappen(a, !ist);
          k.setAttribute('aria-expanded', String(!ist));
        });
      });

      // Start: nächstes Bild vorladen wie der Effekt in v21. Das scrollIntoView des ersten Vorschaubilds beim Start lassen
      // wir weg: oben auf der Seite bewirkt es nichts, beim Zurückgehen würde es die vom Browser wiederhergestellte Lage verschieben.
      vorladen();
    }
  }
  if (!customElements.get('zct-produkt')) customElements.define('zct-produkt', ZctProdukt);

  /* „NAME im Raum.“ wie PdpInstagram in v21: Beiträge per Shortcode von der Schnittstelle, Karte(n) wie IgCard, Medien erst nahe
     am Bildschirm (200 px / 320 px) über zctInstagram.medium; eine Karte = zweispaltig, mehrere = mittig darunter.
     Ohne v19-Daten erscheint der Bereich erst mit den Beiträgen; mit v19-Daten steht der Text schon vom Server. */
  var HAKEN = '<svg class="ig-verified ig-verified-name" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M22 12l-2.32 2.65.32 3.51-3.43.78-1.8 3.04L12 20.56l-2.77 1.42-1.8-3.04-3.43-.78.32-3.51L2 12l2.32-2.65L4 5.84l3.43-.78 1.8-3.04L12 3.44l2.77-1.42 1.8 3.04 3.43.78-.32 3.51L22 12z"></path><path fill="#fff" d="M10.55 15.7l-3.04-3.04 1.24-1.24 1.8 1.8 4.7-4.7 1.24 1.24-5.94 5.94z"></path></svg>';
  class ZctProduktIg extends HTMLElement {
    connectedCallback() {
      if (this._zct) return; this._zct = true;
      var el = this;
      var codes = (this.getAttribute('data-codes') || '').split(',').filter(Boolean);
      var logo = this.getAttribute('data-logo');
      var api = this.getAttribute('data-api');
      var T = {}; try { T = JSON.parse(this.querySelector('script[data-zct-ig-text]').textContent); } catch (e) {}
      if (!codes.length || !api) return;
      var zeilen = T.v19 ? (Array.isArray(T.zeilen) ? T.zeilen : []) : String(T.zeilen || '').split('\n');
      zeilen = zeilen.map(function (z) { return String(z || '').trim(); }).filter(Boolean);
      function zahl(x) { return Number(x).toLocaleString(zctT('v25_intl_zahl')); }
      function karte(item) {
        return '<div class="ig-card ig-card-static pdp-ig-card" style="cursor: default; --media-ratio: 1;"><div class="ig-top"><img class="ig-avatar" src="' + esc(logo) + '" alt="zincutec" loading="lazy"><span class="ig-user"><b>zincutec' + HAKEN + '</b><small>Instagram</small></span><span class="ig-menu" aria-hidden="true">•••</span></div>' +
          '<div class="ig-media-frame"><span class="ig-media" aria-hidden="true"></span></div>' +
          '<div class="ig-actions" aria-hidden="true"><span class="ig-action-with-count"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M20.8 4.6a5.5 5.5 0 00-7.8 0L12 5.6l-1-1a5.5 5.5 0 00-7.8 7.8l1 1L12 21l7.8-7.6 1-1a5.5 5.5 0 000-7.8z"></path></svg>' + (item.like_count > 0 ? '<b>' + zahl(item.like_count) + '</b>' : '') + '</span>' +
          '<span class="ig-action-with-count"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M21 11.5a8.4 8.4 0 01-.9 3.8 8.5 8.5 0 01-7.6 4.7 8.4 8.4 0 01-3.8-.9L3 21l1.9-5.7a8.4 8.4 0 01-.9-3.8 8.5 8.5 0 014.7-7.6 8.4 8.4 0 013.8-.9h.5a8.5 8.5 0 018 8v.5z"></path></svg>' + (item.comments_count > 0 ? '<b>' + zahl(item.comments_count) + '</b>' : '') + '</span>' +
          '<span><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M22 2L11 13"></path><path d="M22 2l-7 20-4-9-9-4 20-7z"></path></svg></span><span class="ig-save"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M19 21l-7-5-7 5V5a2 2 0 012-2h10a2 2 0 012 2z"></path></svg></span></div></div>';
      }
      function zeichnen(items) {
        var single = items.length === 1;
        var alt = el.querySelector('.pdp-instagram');
        // Wie React: neu eingefügt mit {} ohne style-Attribut, nach einem Zwischenstand (v19-Text) bleibt style="" stehen
        var textStil = single ? (alt ? ' style=""' : '') : ' style="text-align: center; max-width: 640px; margin: 0px auto;"';
        var absaetze = zeilen.map(function (z, i) { return '<p style="margin: ' + (i > 0 ? '12px 0px 0px' : '0px') + ';">' + (T.v19 ? z : esc(z)) + '</p>'; }).join('');
        var h = '<div class="pdp-instagram" style="padding: 80px 0px;"><div style="max-width: 1200px; margin: 0px auto; padding: 0 var(--gutter); display: grid; grid-template-columns: ' + (single ? '1fr 1fr' : '1fr') + '; gap: ' + (single ? 60 : 48) + 'px; align-items: center;">' +
          '<div class="pdp-ig-text"' + textStil + '>' + (T.kopf || '') +
          '<div style="color: var(--ink-2); line-height: 1.7; max-width: 32em;' + (single ? '' : ' margin: 32px auto 0px;') + '">' + absaetze + '</div></div>' +
          (single ? '<div style="display: flex; justify-content: center;">' + karte(items[0]) + '</div>'
            : '<div class="pdp-ig-grid" style="display: flex; flex-wrap: wrap; gap: 20px; justify-content: center; max-width: 1200px; margin: 0px auto; width: 100%;">' + items.map(karte).join('') + '</div>') +
          '</div></div>';
        var tmp = document.createElement('div'); tmp.innerHTML = h;
        var neu = tmp.firstChild;
        if (alt) alt.replaceWith(neu); else el.appendChild(neu);
        // Medien erst nahe am Bildschirm (DeferredInstagramMedia)
        var karten = neu.querySelectorAll('.pdp-ig-card');
        var beob = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            if (!e.isIntersecting) return;
            beob.unobserve(e.target);
            var k = e.target.closest('.pdp-ig-card'), i = Array.prototype.indexOf.call(karten, k), item = items[i];
            if (!item || !window.zctInstagram) return;
            window.zctInstagram.medium(e.target.closest('.ig-media-frame'), item, item.poster, function (w, hh) {
              if (!w || !hh) return; var r = Math.max(0.55, Math.min(1.95, w / hh)); k.style.setProperty('--media-ratio', String(r));
            });
          });
        }, { rootMargin: '200px 320px' });
        neu.querySelectorAll('.ig-media-frame > span.ig-media').forEach(function (s) { beob.observe(s); });
      }
      fetch(api + '?shortcodes=' + encodeURIComponent(codes.join(',')) + '&limit=100&comments=0&pages=25', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function (data) {
          var alle = data.items || data.data || [];
          var items = codes.map(function (sc) {
            var m = alle.find(function (i) { return (i.permalink || '').indexOf(sc) >= 0; });
            if (!m) return null;
            var roh = Array.isArray(m.children) ? m.children : (m.children && m.children.data) || [];
            var kinder = roh.map(function (c) { return { id: c.id, src: c.media_url || c.thumbnail_url, poster: c.thumbnail_url || c.media_url, type: c.media_type || 'IMAGE' }; }).filter(function (c) { return c.src; });
            return { id: m.id, type: m.media_type || 'IMAGE', src: m.media_url || m.thumbnail_url, poster: m.thumbnail_url || m.media_url, href: '', caption: m.caption, like_count: m.like_count || 0, comments_count: m.comments_count || 0, children: kinder };
          }).filter(Boolean);
          if (items.length) zeichnen(items);
        }).catch(function () {});
    }
  }
  if (!customElements.get('zct-produkt-ig')) customElements.define('zct-produkt-ig', ZctProduktIg);
})();

/* ZCT_V26_SPALTEN: Am Rechner bleiben beide Spalten der Produktseite stehen. Die Bildspalte klebt unter der Leiste; die rechte
   Spalte läuft mit, bis ihr Ende sichtbar ist, und bleibt dann stehen (top = Fensterhöhe − Spaltenhöhe, höchstens unter der Leiste).
   So entsteht beim Scrollen keine weiße Lücke, egal welche Spalte länger ist. */
(function () {
  'use strict';
  var MQ = window.matchMedia('(min-width: 1024px)');
  function start() {
    var info = document.querySelector('.zd-pdp .info');
    var nav = document.querySelector('nav.nav');
    if (!info || !nav) return;
    function setzen() {
      if (!MQ.matches) { info.style.removeProperty('top'); return; }
      var oben = nav.offsetHeight || 65;
      var top = Math.min(oben, window.innerHeight - info.offsetHeight);
      info.style.top = top + 'px';
    }
    setzen();
    window.addEventListener('resize', setzen);
    if (window.ResizeObserver) new ResizeObserver(setzen).observe(info);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();

  // Handy-Figma „Kürzlich angesehen“: zuletzt angesehene Produkte nur auf diesem Gerät (localStorage, höchstens 10), ohne das aktuelle.
  // Karten aus der Produktliste (#zct-produkte über zctLaden), Pfeile scrollen um zwei Karten. Nur bis 768 px sichtbar (CSS).
  (function zuletzt() {
    var box = document.querySelector('[data-zd-zuletzt]');
    if (!box) return;
    var jetzt = box.getAttribute('data-aktuell'), liste = [];
    try { liste = JSON.parse(localStorage.getItem('zd-zuletzt') || '[]'); } catch (e) { liste = []; }
    if (!Array.isArray(liste)) liste = [];
    var andere = liste.filter(function (h) { return h && h !== jetzt; });
    try { localStorage.setItem('zd-zuletzt', JSON.stringify([jetzt].concat(andere).slice(0, 10))); } catch (e) {}
    function zeichnen() {
      var L = window.zctLaden; if (!L || !L.produkte) return;
      var ROOT = ((window.Shopify && Shopify.routes && Shopify.routes.root) || '/').replace(/\/$/, '');
      var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); };
      var karten = andere.map(function (h) { return L.produkte.find(function (x) { return x.handle === h; }); }).filter(Boolean).slice(0, 8);
      if (!karten.length) return;
      var ab = ''; try { var tj = document.getElementById('zct-texte'); ab = (tj ? JSON.parse(tj.textContent).ab : '') || ''; } catch (e) {}
      box.querySelector('.zd-zuletzt-spur').innerHTML = karten.map(function (x) {
        var preise = (x.varianten || []).filter(function (v) { return v && v.a; }).map(function (v) { return v.p; }).filter(function (v) { return v; });
        var mehr = preise.length > 1 && preise.some(function (v) { return v !== preise[0]; });
        var bild = x.img ? '<img src="' + esc(L.bildUrl(x.img, 400)) + '" srcset="' + esc(L.bildUrl(x.img, 320)) + ' 320w, ' + esc(L.bildUrl(x.img, 480)) + ' 480w" sizes="159px" alt="' + esc(x.name) + '" width="159" height="159" loading="lazy" decoding="async">' : '';
        return '<a class="zd-zk" href="' + esc(ROOT + '/products/' + encodeURIComponent(x.handle)) + '"><span class="zd-zk-bild">' + bild + '</span><span class="zd-zk-text"><span class="zd-zk-name">' + esc(x.name) +
          '</span><span class="zd-zk-kat">' + esc(x.katText || '') + '</span>' + (x.preis ? '<span class="zd-zk-preis">' + (mehr && ab ? esc(ab) + ' ' : '') + esc(L.fmt(x.preis / 100)) + '</span>' : '') + '</span></a>';
      }).join('');
      box.hidden = false;
      var spur = box.querySelector('.zd-zuletzt-spur'), zur = box.querySelector('[data-zd-zurueck]'), vor = box.querySelector('[data-zd-weiter]');
      var ruhig = window.matchMedia('(prefers-reduced-motion: reduce)');
      function knoepfe() { var max = spur.scrollWidth - spur.clientWidth; zur.disabled = spur.scrollLeft <= 4; vor.disabled = spur.scrollLeft >= max - 4; }
      var tick = false;
      spur.addEventListener('scroll', function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; knoepfe(); }); }, { passive: true });
      zur.addEventListener('click', function () { spur.scrollBy({ left: -334, behavior: ruhig.matches ? 'auto' : 'smooth' }); });
      vor.addEventListener('click', function () { spur.scrollBy({ left: 334, behavior: ruhig.matches ? 'auto' : 'smooth' }); });
      knoepfe();
    }
    if (window.zctLaden && window.zctLaden.produkte) zeichnen(); else window.addEventListener('load', zeichnen, { once: true });
  })();
})();

